import React, {Fragment} from 'react';
import * as S from './SupplierProgressCard.styles';
import SuppliersProgressList from '../SupplierProgressList/SupplierProgressList';
import SuppliersProgressBar from '../SuppliersProgressBar/SuppliersProgressBar';
import {
  ISupplierProgressComponentData,
  ISupplierProgressBarInformationData,
} from '../../../../../shared/types/aisProfile';

const SuppliersProgressCard: React.FC<ISupplierProgressComponentData> = (
  progressCardData,
): React.ReactElement => {
  const {order} = progressCardData;

  const isProgressInformationBarComponent = (
    obj: any,
  ): obj is ISupplierProgressBarInformationData => {
    return obj && obj.data.footer;
  };

  const isProgressInformationRequiredDetails = (
    obj: any,
  ): obj is ISupplierProgressBarInformationData => {
    return obj && obj.data.items;
  };

  const renderComponent = (element): React.ReactElement => {
    if (isProgressInformationBarComponent(progressCardData[element])) {
      return <SuppliersProgressBar {...progressCardData[element]?.data} />;
    } else if (isProgressInformationRequiredDetails(progressCardData[element])) {
      return <SuppliersProgressList {...progressCardData[element]?.data} />;
    }
  };

  return (
    <S.SupplierProgressCardMainWrap>
      <div className="suppliersProgressCard">
        {order?.length &&
          order.map((item, idx) => {
            return <Fragment>{renderComponent(item)}</Fragment>;
          })}

        {/*
        =====================CAN BE REQUIRED LATER================
         <SuppliersProgressBar data={data} />
        {data.verificationStatus === 'inProcess' ? (
          <span className="font14 lineHeight20 latoBold  verifiedPersuasion inProcess ">
            Your details are being verified.{' '}
          </span>
        ) : data.verificationStatus === 'verified' ? (
          <span className="font14 lineHeight20 latoBold  verifiedPersuasion verified ">
            Congratulations! Your deatils are verified and supplier profile now active
          </span>
        ) : data.verificationStatus === 'inValid' ? (
          <span className="font14 lineHeight20  verifiedPersuasion inValid">
            Verification documents have failed. Please contact your business manager for further
            details{' '}
          </span>
        ) : null}
        <p className="font14 lineHeight20 secondaryTxt appendTop8">
          Complete your account activation by adding your bank details and Flight PNR number to your
          supplier profile
        </p>
        <SuppliersProgressList data={data.suppliersList} customClass="appendTop24" /> */}
      </div>
    </S.SupplierProgressCardMainWrap>
  );
};

export default SuppliersProgressCard;
